var _rect, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "#E6E7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 56,
    height: 56,
    fill: "#0055FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 41L58 57L42 73L26 57L42 41Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1693_231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 29,
    width: 56,
    height: 56,
    fill: "url(#paint0_linear_1693_231)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.609 53.7156C116.051 50.7681 113.805 49.1833 110.737 48.1258L111.732 44.132L109.302 43.5273L108.332 47.4156C107.694 47.2553 107.038 47.1062 106.384 46.9572L107.362 43.0436L104.932 42.4375L103.936 46.4298C103.407 46.3089 102.887 46.1908 102.384 46.0642L102.386 46.0516L99.034 45.2148L98.3871 47.8108C98.3871 47.8108 100.191 48.2242 100.153 48.2495C101.138 48.4956 101.315 49.1467 101.285 49.6642L100.152 54.2134C100.219 54.2303 100.307 54.2556 100.405 54.2936L100.148 54.2303L98.5587 60.6034C98.4377 60.9016 98.1326 61.3502 97.4435 61.18C97.4688 61.2152 95.6773 60.7398 95.6773 60.7398L94.4707 63.5214L97.6348 64.3103C98.2226 64.458 98.7991 64.6127 99.3659 64.7575L98.3604 68.7962L100.789 69.4009L101.785 65.4072C102.448 65.5858 103.092 65.7517 103.722 65.9092L102.73 69.8861L105.16 70.4908L106.165 66.4605C110.311 67.2452 113.427 66.9287 114.739 63.1797C115.796 60.1619 114.687 58.4195 112.506 57.2847C114.095 56.9191 115.29 55.8742 115.609 53.7156ZM110.055 61.5034C109.305 64.5227 104.222 62.89 102.574 62.4808L103.909 57.13C105.558 57.542 110.841 58.3563 110.055 61.5034ZM110.807 53.672C110.122 56.4184 105.892 55.022 104.521 54.6803L105.731 49.8287C107.102 50.1705 111.521 50.8075 110.807 53.672Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1693_231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 63,
    width: 56,
    height: 56,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4925 91.3692L73.9966 71L61.4973 91.3709L73.9966 98.6274L86.4925 91.3692ZM86.5025 93.6981L73.9966 100.951L61.4973 93.6997L73.9966 111L86.5025 93.6981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9958 71V85.7864L86.4935 91.3709L73.9958 71ZM73.9958 100.953V111L86.5018 93.6981L73.9958 100.953Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9958 98.6277L86.4935 91.3712L73.9958 85.79V98.6277Z",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4973 91.3712L73.9966 98.6277V85.79L61.4973 91.3712Z",
    fill: "#C0CBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_231",
    x1: 105.985,
    y1: 28.9866,
    x2: 105.985,
    y2: 84.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_231"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1693_231"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 29,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1693_231"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 63,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpool);
export default __webpack_public_path__ + "static/media/WEBPOOL.53bb85598fd850c6617d29f2dec3789d.svg";
export { ForwardRef as ReactComponent };